module.exports = __webpack_public_path__ + "static/media/smallScreenHome.d777f0ce.svg";